import { RestService } from "./RestService";

export class EVoucherOrderService extends RestService {
  constructor(errorHandler) {
    super("api/v1/evoucher_orders", "application/json", errorHandler);
  }

  archive(id) {
    return this.postImpl(`${id}/archive`, {});
  }

  approve(id, payload) {
    return this.postImpl(`${id}/approve`, payload);
  }

  reject(id, payload) {
    return this.postImpl(`${id}/reject`, payload);
  }

  cancel(id, payload) {
    return this.postImpl(`${id}/cancel`, payload);
  }
}
